import InfoHintContainer from './InfoHintContainer';

export default InfoHintContainer;
